import { Action, ActionType } from 'typesafe-actions';
import { ofType } from 'redux-observable';
import { Observable, of, OperatorFunction } from 'rxjs';
import { catchError, groupBy, map, mergeMap, switchMap } from 'rxjs/operators';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import { toReduxError } from '@universal/errors';
import { Actions, DocumentData, actions } from '@redux/modules/documents';
import { TypedEpic } from './types';

type GetDocumentRequest = ActionType<typeof actions.getDocument.request>;

// Per slug, so requests for different documents don't cancel each other.
export const fetchDocumentEpic: TypedEpic = (action$: Observable<Action<any>>) =>
  action$.pipe(
    ofType(Actions.GET_DOCUMENT) as OperatorFunction<Action<any>, GetDocumentRequest>,
    groupBy((action) => action.payload),
    mergeMap((group$) =>
      group$.pipe(
        switchMap((action) => {
          const headers: Record<string, string> = {};

          if (typeof document !== 'undefined') {
            headers.Location = document.location.href;
          }

          return fromApiRequest((signal) =>
            apiClient.get<DocumentData>(ApiType.apimNafNoApi, {
              signal,
              url: ApiPaths[ApiType.apimNafNoApi].documents.get(action.payload),
              headers,
            }),
          ).pipe(
            map((response) => actions.getDocument.success(response.data, { id: action.payload })),
            catchError((error) =>
              of(actions.getDocument.failure(toReduxError(error, 'Could not get document'), { id: action.payload })),
            ),
          );
        }),
      ),
    ),
  );

export const epics: TypedEpic[] = [fetchDocumentEpic];
